/* The mockup's `.share-bar`: a thin meter with its percentage beside it. */
.share {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  min-inline-size: 120px;
}

.bar {
  flex: 1;
  inline-size: 100%;
  block-size: 6px;
  border: 0;
  border-radius: var(--radius-pill);
  background: var(--surface-strong);
  accent-color: var(--action-surface);
  -webkit-appearance: none;
  appearance: none;
  overflow: hidden;
}

.bar::-webkit-progress-bar {
  background: var(--surface-strong);
}

.bar::-webkit-progress-value {
  background: var(--action-surface);
  border-radius: var(--radius-pill);
}

.bar::-moz-progress-bar {
  background: var(--action-surface);
  border-radius: var(--radius-pill);
}

.percent {
  color: var(--text-subtle);
  font-size: var(--font-size-12);
  font-variant-numeric: tabular-nums;
}

/* Mockup v3 P9: the detail card's head, its title and "Agrupar por" on one line. */
.head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
}

.grouping {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}
